import CommunityObject from "./CommunityObject";

export default class TagObject extends CommunityObject {
  constructor(tag) {
    super(TagObject.name);
    this.id = Number(tag.id);
    this.title = String(tag.title);
    this.truncatedTitle = String(this.truncate(this.title));
    this.validate();
  }
  truncate(title) {
    const maxLength = 20;
    const suffix = "...";
    if (title.length < maxLength) return title;
    return title.substr(0, maxLength - suffix.length) + suffix;
  }
  static toJSON() {
    id: this.id;
    title: this.title;
    truncatedTitle: this.truncatedTitle;
  }
}
